var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "section", attrs: { id: "orders" } },
    [
      _vm.withTitle
        ? _c("div", { staticClass: "section-title" }, [
            _vm._v("\n    CONFIRME SEU PEDIDO\n    "),
            _c("hr")
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "details mb-20", class: { small: _vm.small } }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "column" }, [
            _c("span", [
              _vm._v("\n          Dia:\n          "),
              _c("b", [
                _vm._v(_vm._s(_vm._f("formatDate")(_vm.day, "DD/MM/Y")))
              ])
            ]),
            _vm._v(" "),
            _c("span", [
              _vm._v("\n          Horário:\n          "),
              _c("b", [_vm._v(_vm._s(_vm.labelDuration))])
            ]),
            _vm._v(" "),
            _c("span", [
              _vm._v("\n          Duração:\n          "),
              _c("b", [
                _vm._v(
                  _vm._s(_vm.duration) +
                    " " +
                    _vm._s(_vm.duration > 1 ? "horas" : "hora")
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "column", staticStyle: { flex: "1.4" } }, [
            _c("span", [
              _vm._v("\n          Profissional:\n          "),
              _c("b", [
                _vm._v(
                  _vm._s(_vm.professional.account.first_name) +
                    " " +
                    _vm._s(_vm.professional.account.last_name)
                )
              ])
            ]),
            _vm._v(" "),
            _c("span", [
              _vm._v("\n          Valor:\n          "),
              _c("b", [_vm._v(_vm._s(_vm._f("intToCurrency")(_vm.totalPrice)))])
            ]),
            _vm._v(" "),
            _c("span", [
              _vm._v("\n          Produtos:\n          "),
              _c("b", [
                _vm._v(
                  _vm._s(
                    _vm.use_my_products
                      ? "Irei usar meus produtos"
                      : "A diarista levará os produtos"
                  )
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "column flex-1" }, [
          _c("b", [_vm._v("Local")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.address.name))]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm._f("fullAddress")(_vm.address)))])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "informations" }, [
          _c("b", [_vm._v("Informações adicionais")]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.additional_informations))])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex justify-center" }, [
          _c(
            "button",
            {
              staticClass: "btn bg-green",
              class: { "btn--loading": _vm.preloader },
              attrs: { disabled: _vm.preloader },
              on: { click: _vm.submit }
            },
            [_c("span", [_vm._v("ir para pagamento")])]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade", mode: "out-in" } },
        [
          _vm.error
            ? _c(
                "modal",
                {
                  attrs: { title: "OPS! ALGO DEU ERRADO ;/", size: "md" },
                  on: {
                    close: function($event) {
                      _vm.error = false
                    }
                  }
                },
                [
                  _c("template", { slot: "body" }, [
                    _c("div", { domProps: { innerHTML: _vm._s(_vm.error) } })
                  ]),
                  _vm._v(" "),
                  _c("template", { slot: "footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn bg-purple-outline",
                        on: {
                          click: function($event) {
                            _vm.error = false
                          }
                        }
                      },
                      [_vm._v("fechar")]
                    )
                  ])
                ],
                2
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("wont-have-instant-support", {
        attrs: { visible: _vm.showWontHaveInstantSupportDialog },
        on: {
          accept: function($event) {
            _vm.acceptWontHaveInstantSupport()
          },
          reject: function($event) {
            _vm.showWontHaveInstantSupportDialog = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-63530e1d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63530e1d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PurchaseFlow/Steps/Confirmation.vue
// module id = null
// module chunks = 